import {FETCH_INVITE, SET_RESPONSE} from "./types";
import {firestore} from "../helpers/firebase";
import {setFailure, setFetching, setInitial, setSubmitting, setSuccess} from "./app-state-action";

const invitesDocName = 'Events';

export const fetchInvite = (id) => {
    return dispatch => {
        dispatch(setFetching());
        firestore.collection(invitesDocName).doc(id).get().then((r) => {
            if (r.data()) {
                dispatch(
                    {
                        type: FETCH_INVITE,
                        payload: r.data()
                    }
                )
                dispatch(setInitial());
            } else {
                dispatch(setFailure("no-doc"));
            }
        }).catch((e) => {
            dispatch(setFailure(e.message));
        });

    }

}

export const responseInvite = (data, id) => {
    return dispatch => {
        dispatch(setSubmitting());
        const docRef = firestore.collection(invitesDocName).doc(id);
        docRef.get().then((r) => {
            let documentData = r.data();
            let userInvites = documentData['userInvites'] ?? [];
            let userItems = documentData['userItems'] ?? [];
            let user = {displayName: data.fullName, email: data.email}
            userInvites.push(
                {
                    state: data.response === 'accept' ? 1 : -1,
                    user: user
                }
            );

            if (data.items.length) {
                userItems.push(
                    {
                        user: user,
                        items: data.items
                    }
                );
            }
            docRef.update({userInvites: userInvites, userItems: userItems})
                .then((r) => dispatch(setSuccess("Your response successfully submitted!")))
                .catch((e) => dispatch(setFailure(e.message)));
        });

    }
}